<template lang="pug">
multiselect(
    track-by="id"
    label="name"
    :options="supplierList"
    :loading="onLoading('fetch-suppliers')"
    @select="onSelect"
    :placeholder="placeholder"
    v-model="value"
    :allow-empty="false"
    select-label=""
    deselectLabel=""
    @search-change="loadSuppliers"
    :internal-search="false"
)
    template(slot="option", slot-scope="props")
        .clear
            span.clear {{ props.option.name }}
            small.clear.text-muted(v-if="props.option.outlet == null") All {{ outlet_name }}s
            small.clear.text-muted(v-else) {{ props.option.outlet }}
            small.clear.text-muted {{ props.option.region }}
            
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import inventorySupplier from '@js/store/modules/inventory-supplier';
import Feature from '@js/plugins/feature';

export default {
    props: {
        placeholder: {
            type: String,
            default: 'Select Distributor',
        },
        include_all_outlets: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        let outlet_name = 'Outlet';

        if (Feature.hasFeature('fuel')) {
            outlet_name = 'Station';
        }

        return {
            value: '',
            outlet_name,
        };
    },

    computed: {
        ...mapGetters('inventorySupplier', ['supplierList']),

        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        activeOutlet() {
            this.getSupplierList({
                outlet_id: this.activeOutlet,
                include_all_outlets: this.include_all_outlets,
            });
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('inventorySupplier')) {
            this.$store.registerModule('inventorySupplier', inventorySupplier);
        }
    },

    mounted() {
        this.loadSuppliers();
    },

    methods: {
        ...mapActions('inventorySupplier', ['getSupplierList']),

        onSelect(supplier) {
            this.$emit('input', supplier);
        },

        loadSuppliers: _.debounce(function(query = '') {
            const params = {
                query,
                outlet_id: this.activeOutlet,
                include_all_outlets: this.include_all_outlets,
            };

            this.getSupplierList(params);
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/supplier-selector.vue